




























































































import {
  BSidebar,
  BForm,
  BButton,
  BCard,
  BCol,
  BFormCheckbox,
  BDropdown,
  BFormGroup,
  BDropdownItem,
  BFormInput,
  BPagination,
  BFormSelect,
  BRow,
  BTable,
  BSpinner,
} from "bootstrap-vue";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import { ChangelogType, UpdateChangelogTypeModel } from "@/api/models/changelogs/changelogType";
import SearchableVueSelect from "@/components/selects/SearchableVueSelect.vue";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";

@Component({
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BFormInput,
    BTable,
    BPagination,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BSidebar,
    BForm,
    BFormGroup,
    BFormCheckbox,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    SearchableVueSelect,
  },
  name: "update-changelog-type",
})
export default class EditChangelogType extends Vue {
  @Prop({ required: true, type: Boolean }) isUpdateChangelogTypeSidebarActive!: boolean;
  @Prop({ required: true }) changelogTypeId!: string;

  loading = false;
  required = required;
  loadingChangelogType = false;



  changelogType: UpdateChangelogTypeModel = {};

  async created() {
    this.loadingChangelogType = true
    await this.$http.myressif.changelogTypes
      .getById(this.changelogTypeId)
      .then((res: ChangelogType) => {
        this.changelogType = res;
        this.loadingChangelogType = false;
      });
  }

  resetForm() {
    this.changelogType = {};
  }

  async submit() {
    this.loading = true;
    await this.$http.myressif.changelogTypes
      .update(
        this.changelogTypeId,
        this.changelogType
      )
      .then(
        async (response: any) => {
          successAlert.fire({
            timer: 3500,
            title: "Modification du type de changelog",
            text: "Type de changelog modifié avec succès",
          });
        },
        (error: any) => {
          if (
            error?.response?.data?.errors &&
            Object.keys(error.response.data.errors).length
          ) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
        }
      )
      .finally(() => {
        this.$emit("refresh-changelog-types");
        this.$emit("update:is-update-changelog-type-sidebar-active", false);
        this.loading = false;
      });
  }
}
